module.exports = __webpack_public_path__ + "static/auto_import_new-7cec6df252d28169259b3eb5a320bab5.webp";